/**
 * Known keys. You don't need to import this as you would still be able to use normalized string.
 * @module keyboard/keys
 */
export const Keys = {
    DOWN: 'Down',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    LEFT: 'Left',
    RIGHT: 'Right',
    SPACE: 'Space',
    TAB: 'Tab',
    UP: 'Up',
    BACKSPACE: 'Backspace'
};
